/**
 * Re-export react-slick with CJS interop fix.
 *
 * react-slick v0.31 is CJS-only. Vite's ESM interop can double-wrap the
 * default export, producing `{ default: Component }` instead of `Component`.
 * This module unwraps it once so every consumer gets the real component.
 *
 * Usage:
 *   import { Slider } from "@/components/ui/slider";
 */

import type { Settings } from "react-slick";
import ReactSlick from "react-slick";

const Slider: typeof ReactSlick =
  typeof ReactSlick === "function"
    ? ReactSlick
    : (ReactSlick as unknown as { default: typeof ReactSlick }).default;

export type { Settings as SliderSettings };
export { Slider };
export type SliderRef = InstanceType<typeof ReactSlick>;
